<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Asignar nueva clave
            <div class="card-actions">
              <button class="btn btn-primary" v-b-tooltip.hover title="Volver al inicio" v-if="!procesando" @click="Inicio()" >
                <i class="icon-arrow-left"></i>
              </button>
            </div>
          </div>
          <div class="card-body">

            <form v-on:submit.prevent="asignarClave" v-if="procesando == false && error == false && cambio_clave == false">
              <h2>Ingrese su nueva clave y confírmela</h2>
              <hr />

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="clave">Contraseña</label>
                    <b-form-input type="password" :state="validarClave()" v-model="clave" name="clave" :disabled="procesando" placeholder="Ingrese contraseña"></b-form-input>
                    <b-form-valid-feedback>
                      Clave válida.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese una clave válida. Debe contener mínimo (8) carácteres entre números, carácteres especiales, letras mayúsculas y minúsculas.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="confirmacion_clave">Confirmación Contraseña</label>
                    <b-form-input type="password" :state="validarConfirmacionClave()" v-model="confirmacion_clave" name="confirmacion_clave" :disabled="procesando" placeholder="Ingrese confirmación contraseña"></b-form-input>
                    <b-form-valid-feedback>
                      Confirmación clave válida.
                    </b-form-valid-feedback>
                    <b-form-invalid-feedback>
                      Ingrese confirmación clave.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <h2>Asignar nueva clave</h2>
              <hr />

              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <b-button type="button" variant="secondary" style="cursor: not-allowed;" disabled v-if="!validarFormulario ()" v-b-tooltip.hover title="Recuperar clave"><i class="fa fa-floppy-o fa-lg"></i></b-button>
                    <b-button type="submit" variant="primary" v-if="validarFormulario ()" v-b-tooltip.hover title="Recuperar clave"><i class="fa fa-floppy-o fa-lg"></i></b-button>
                  </b-form-group>
                </b-col>
              </b-row>

            </form>
            <b-alert show class="text-center" variant="info" v-if="procesando == true">
              <b-progress height="20px" :max="100" variant="info" striped :animated="true">
                <b-progress-bar :value="100" :label="'&lt;strong&gt;Procesando...&lt;/strong&gt;'">
                </b-progress-bar>
              </b-progress>
            </b-alert>
            <b-alert show class="text-center" variant="info" v-else-if="procesando == false && error == false && cambio_clave == true">
              <h3>Felicitaciones!!!</h3>
              {{mensaje_success}}
              <br />
              <br />
              <b-button type="button" variant="success" @click="abrirModalInicioSesion()">Iniciar sesión</b-button>
            </b-alert>
            <b-alert show class="text-center" variant="danger" v-else-if="procesando == false && error == true && cambio_clave == false">
              {{mensaje_error}}
            </b-alert>

          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->

  </div>
</template>

<script>
import router from '@/router/index.js'
import usuario from '@/js/usuario.js'

import validationField from 'validationField'

export default {
  name: 'usuario-verificar-cuenta',
  mounted () {
    this.cambio_clave = false
    this.procesando = false
    this.error = false

    this.correo_electronico = this.$route.params.correo_electronico
    this.token_verificacion = this.$route.params.token_verificacion
    // console.log(this)
  },
  data () {
    return {
      procesando: false,
      error: false,
      cambio_clave: false,
      token_verificacion: null,
      correo_electronico: '',
      clave: '',
      confirmacion_clave: '',
      mensaje_error: 'Se ha presentado un error en el sistema. Por favor intente más tarde. Si el error continua por favor comuníquese con el administrador del sistema.',
      mensaje_success: 'Clave asignada satisfactoriamente. Ya puede iniciar sesión.'
    }
  },
  methods: {
    validarFormulario () {
      let valido = true

      if (
        !this.validarClave() ||
        !this.validarConfirmacionClave()
      ) {
        valido = false
      }
      return valido
    },
    validarClave () {
      let valido = true

      if (!this.clave || !validationField('password', this.clave)) {
        valido = false
      }
      return valido
    },
    validarConfirmacionClave () {
      let valido = true

      if (!this.confirmacion_clave || this.clave !== this.confirmacion_clave) {
        valido = false
      }
      return valido
    },
    asignarClave () {
      this.cambio_clave = false
      this.procesando = true
      this.error = false

      usuario.asignar_clave.token_verificacion = this.token_verificacion
      usuario.asignar_clave.correo_electronico = this.correo_electronico
      usuario.asignar_clave.clave = this.clave
      usuario.asignar_clave.confirmacion_clave = this.confirmacion_clave
      usuario.asignarClave().then(response => {
        if (response.status === 'success') {
          this.cambio_clave = true
          this.procesando = false
          this.error = false
        } else {
          this.cambio_clave = false
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    abrirModalInicioSesion () {
      this.Inicio()
      this.$parent.$parent.$children[0].$children[1].abrirModalInicioSesion()
    },
    Inicio () {
      router.push({
        name: 'home'
      })
    }
  }

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Usuario/AsignarClave.vue